module.exports = __webpack_public_path__ + "static/media/dlc_close.cf6b6a83.svg";